<template>
    <modal :customStyle="customStyle" @closed="close" :allowCancel="false" :contentOverflow=false>
            <div class="add-date">
                <h2 class="add-date--heading" v-text="$t('SEND_GIFT_TITTLE')"/>
                <p class="add-date--sub-heading" v-text="$t('SEND_GIFT_DESCRIPTION')"></p>
                <div class="date-select">
                    <multiselect
                        class="date-select--event"
                        v-model="selectedReminder"
                        track-by="name"
                        label="name"
                        :allow-empty="false"
                        placeholder="Select the event"
                        :options="specialDates"
                        :close-on-select="true"/>
                </div>
                <p class="input-error" v-if="showDateError">{{showDateError[0]}}</p>
            </div>
            <button
              slot="actions-suffix"
              :disabled="isProcessing"
              @click="sendGift"
              class="btn btn--green add-date-btn--add">{{$t('GIFTING_REMINDERS_SEND_GIFT')}}</button>
    </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import Modal from '@/components/structure/Modal.vue';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';

export default {
    name: 'SendGiftModal',
    components: {
        Modal,
        Multiselect,
    },
    data() {
        return {
            selectedReminder: '',
            errorHandler: new ErrorResponseHandler(),
            isProcessing: false,
        };
    },
    computed: {
        ...mapGetters({
            specialDates: 'specialDates/getSpecialDates',
            specialDatesEnabled: 'account/getSpecialDatesEnabled',
        }),
        showDateError() {
            return this.errorHandler.response.date;
        },
        customStyle() {
            return {
                'max-width': '728px',
                'max-height': '564px',
                'border-radius': '8px',
            };
        },
    },
    methods: {
        close() {
            this.$emit('closed');
        },
        sendGift() {
            this.$store.commit('specialDates/updatedSelectedOccassion', this.selectedReminder);
            this.$router.push({ name: 'account.gifting' });
        },
    },
};
</script>

<style lang="scss" scoped>
.add-date {
    max-width: 600px;
    margin: 0 auto;
    &--heading {
        font-size: 25px;
        font-weight: 400;
        line-height: 30px;
        letter-spacing: 0em;
        text-align: left;
    }

    &--sub-heading {
        font-size: 16px;
        font-weight: 300;
        line-height: 22px;
        letter-spacing: -0.011em;
        text-align: left;
    }

    &--questions {
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
        margin-top: 24px;
    }

    &-btn {
        &--cancel, &--add {
            width: 327px;
            height: 55px;
            margin: 10px 10px;
        }
    }
    &--input {
        width: 100%;
        border: 1px solid #707070;
        padding: 10px 20px;
        color: #1a1a1a;
        font-weight: 200;
        &::placeholder {
            color: #1a1a1a;
        }
    }
}

.date-select {
    display: flex;
    &--day, &--event, &--year {
        height: 60px;
        width: 110px;
        left: 0px;
        top: 0px;
        border-radius: 2px;
        @media (max-width: 640px) {
            margin: 0 5px;
        }
    }
    &--day{
        margin-left: 0;
    }
    &--event {
        width: 540px;
        margin: 0px;
    }
}
.input-error {
    line-height: 15px;
    display: block;
    color: #b1473c;
    margin-bottom: 1.5rem;
    margin-top: 0.75rem;
    width: 100%;
    font-weight: 200;
    font-size: .75rem;
}

    @media (min-width: 768px){
        .add-date {
            max-width: 540px;
            &-btn {
                &--cancel, &--add {
                    width: 540px;
                    height: 55px;
                    margin: 10px 10px;
                }
            }
        }

        .date-select {
            &--month {
                width: 408px;
                margin: 0px;
                margin-left: 20px;
            }
        }
    }

    @media (min-width: 480px) and (max-width: 767px){
        .add-date {
            max-width: 400px;
            &-btn {
                &--cancel, &--add {
                    width: 375px;
                    height: 55px;
                    margin: 10px 10px;
                }
            }
        }

        .date-select {
            &--month {
                width: 308px;
                margin: 0px;
                margin-left: 20px;
            }
        }
    }
</style>
